import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ProductBrandNameApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PRODUCT_BRAND_NAME);
  }
}

export default new ProductBrandNameApi();
